import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { Backdrop as MuiBackdrop } from '@mui/material';

/**
 * Material-UI Backdrop wrapper, calls onClick if document.mouseDown or escape key press are captured
 * @param { String } open
 * @param { Function } onClick
 */
const Backdrop = ({ show, onClick }) => {
  const handleClickOutside = e => {
    onClick(e);
  };

  const onKeyDown = e => {
    if (e.keyCode === 27) {
      // ESCAPE key pressed
      onClick(e);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', onKeyDown);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return <MuiBackdrop open={show} className={'backdrop'} />;
};

Backdrop.propTypes = {
  show: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};

export default Backdrop;
